import { EmptystateLinkColored } from "components/icons/generated";
import CardCollapsible from "ds/components/Card/Collapsible";
import Counter from "ds/components/Counter";
import EmptyState from "ds/components/EmptyState";
import { useToggle } from "hooks/useToggle";
import useAutoExpandOnValueChange from "ds/components/Card/Collapsible/useAutoExpandOnValueChange";

import NewContextAttachedProject from "../AttachedProject";
import { AttachedProject } from "../AttachedProject/types";

type NewContextManuallyAttachedProjectsProps = {
  items: AttachedProject[];
  onDetach: (id: string) => void;
};

const NewContextManuallyAttachedProjects = ({
  items,
  onDetach,
}: NewContextManuallyAttachedProjectsProps) => {
  const [isCollapsed, toggle] = useToggle(true);

  useAutoExpandOnValueChange(items.length, toggle);

  return (
    <CardCollapsible
      ariaLevel={2}
      ariaLabel="Attached directly"
      title="Attached directly"
      isCollapsed={isCollapsed}
      onToggle={toggle}
      titleSuffix={<Counter count={items.length} />}
      contentGap="medium"
    >
      {items.length === 0 ? (
        <EmptyState
          padding="large 0"
          icon={EmptystateLinkColored}
          title="Context is not attached to any items"
          caption="Use projects list to attach context to any of stacks or modules."
        />
      ) : (
        <>
          {items.map((item) => (
            <NewContextAttachedProject key={item.id} item={item} onDetach={onDetach} />
          ))}
        </>
      )}
    </CardCollapsible>
  );
};

export default NewContextManuallyAttachedProjects;
